<div class="container margin_60_35">
  <router-outlet></router-outlet>
</div>
